import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, Button, Chip, Typography, useTheme } from '@mui/material';

interface FloatingButtonFieldProps {
  label: string;
  open?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  chipList: string[];
}

export default function FloatingLabelButton({
  label,
  open = false,
  onClick,
  chipList
}: FloatingButtonFieldProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%'
      }}
    >
      <Typography
        component="span"
        sx={{
          position: 'absolute',
          top: 0,
          left: 10,
          zIndex: 1,
          transform: 'translateY(-50%)',
          px: 0.5,
          bgcolor: 'white',
          color: 'text.primary',
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: 1
        }}
      >
        {label}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={onClick}
        sx={{
          color: 'text.primary',
          backgroundColor: 'white',
          borderRadius: theme.spacing(1),
          maxWidth: '400px',
          width: '100%',
          minHeight: '36px',
          borderColor: (theme) =>
            open ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.23)',
          '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.87)',
            backgroundColor: 'white'
          },
          '& .MuiButton-startIcon': { marginRight: 'auto' },
          '& .buttonText': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
            textAlign: 'left',
            flex: '1'
          },
          padding: '8px'
        }}
        endIcon={
          <KeyboardArrowDown
            sx={{
              transform: open ? 'rotate(180deg)' : 'rotate(0)',
              marginRight: '2px'
            }}
          />
        }
      >
        {chipList.length <= 0 ? (
          <span className="buttonText">All {label}</span>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'nowrap',
              gap: 0.5,
              // maxWidth: '320px',
              // maxWidth: '500px',
              width: '100%',
              overflow: 'scroll',
              scrollbarWidth: 'none'
            }}
          >
            {chipList.map((chip, index) => (
              <Chip
                key={`${chip}-${index}`}
                variant="outlined"
                sx={{
                  maxWidth: chipList.length > 1 ? '150px' : '300px',
                  '& .MuiChip-label': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block'
                  }
                }}
                label={chip}
                size="small"
              />
            ))}
          </Box>
        )}
      </Button>
    </Box>
  );
}
